export default __webpack_public_path__ + "static/media/mockup-mdh.2fefd529.png";